var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"asc-page-coming-soon"},[_c('asc-header',{attrs:{"size":"h2","value":_vm.label}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }